<template>
    <div class="problemData">
        <van-cell-group style="margin-bottom: 10px;">
            <van-field disabled label="选择分类" v-model="addfbForm.tname" input-align="right" placeholder="自动获取，不可编辑" />

            <van-field required label="问题标题：" v-model="addfbForm.title" input-align="right" placeholder="请输入标题" />

            <van-field required type="textarea" label="问题描述:" v-model="addfbForm.strcount" placeholder="请输入内容，仅限500字"
                rows="5" maxlength="500" show-word-limit input-align="right" autosize />
            <van-field required label="图片:" style="align-items: center;" input-align="right">
                <template #input>
                    <van-uploader style="width:100%;max-height:200px;overflow-y: auto;" ref="upload"
                        v-model="addfbForm.fileList" multiple accept=".jpg,.jpeg,.png,.JPG,.JPEG"
                        :after-read="afterRead" />
                </template>
            </van-field>
        </van-cell-group>
        <div style="width: 90%; margin: 20px auto;display: flex;">
            <van-button type="default" style="width: 40%; margin: auto" round @click="continueBtn()">取消</van-button>
            <van-button :loading="loading" type="info" style="width: 40%; margin: auto" round
                @click="onSubmit()">确认</van-button>
        </div>
    </div>
</template>
<script>
import {
    AddYwFeedback
} from "@/api/index";
export default {

    name: "problemData",
    data() {
        return {
            questionInfo: {},
            addfbForm: {
                tname: '',
                title: '',
                strcount: '',
                fileList: []
            },
            fileList: [],
            upOrdelUser: [],
            replyUser: [],
            loading: false,
        }
    },
    methods: {
        afterRead(v, files) {
            // this.addfbForm.fileList = v;
        },
        continueBtn() {
            this.$router.push({
                path: "/home/menu/construction",
                query: { type: 0, title: '建设运维' },
            });
        },
        onSubmit() {
            if (this.addfbForm.title == '' || this.addfbForm.strcount === "" || this.addfbForm.fileList.length === 0) {
                this.$toast("请填写完整数据");
                return false;
            } else {
                this.loading = true;
                let fd = new FormData();
                this.addfbForm.fileList.forEach((file) => {
                    fd.append("filses", file.file);
                });
                fd.append("projectid", this.$store.state.pid);
                fd.append("type", this.$route.query.type);
                fd.append("fileId", 0);
                fd.append("treeid", this.$route.query.feed.id);
                fd.append("title", this.addfbForm.title);
                fd.append("strcount", this.addfbForm.strcount);
                AddYwFeedback(fd).then((res) => {
                    if (res.Code != 0) {
                        this.$Notify({ type: "success", message: "操作成功!" });
                        this.addfbForm = {
                            tname: '',
                            title: '',
                            strcount: '',
                            fileList: []
                        };
                        this.$router.go(-1);
                        // this.$refs.upload.clearFiles();
                        // this.getDataList();
                    } else {
                        this.$Notify({ type: "danger", message: res.Message });
                    }
                    this.loading = false;
                });
            }
        }
    },
    mounted() {
        this.upOrdelUser = this.$route.query.upOrdelUser;
        this.replyUser = this.$route.query.replyUser;
        this.addfbForm.tname = this.$route.query.feed.tname;
        // this.getData()

    },
}
</script>
<style lang="scss" scoped>
.problemData {
    width: 100%;
    height: 100%;
    background: #fff;
}
</style>
